import { FlowRoute, FlowRouteCategory, FlowActions } from '@eneco/flows/types';

import { resetProduct } from './actions';
import { createSelectedProductsMap, energyTypeProducts } from './helpers';
import { ProductSelectionStep, CompanyDetailsStep, ThankYouStep } from './steps';
import { B2BLeadFlowContext } from './types';

export const initialContext: B2BLeadFlowContext = {
  selectedProducts: createSelectedProductsMap([energyTypeProducts[0]]),
  otherRequestDescription: '',
  otherOptions: false,
};

export const routes: FlowRoute<B2BLeadFlowContext>[] = [
  {
    id: 'PRODUCT_SELECTION',
    path: '/product-keuze/',
    category: FlowRouteCategory.ProductSelection,
    component: ProductSelectionStep,
    actions: ['resetProduct'],
  },
  {
    id: 'DETAILS',
    path: '/gegevens/',
    category: FlowRouteCategory.Details,
    component: CompanyDetailsStep,
  },
  {
    id: 'THANK_YOU',
    path: '/bedankt/',
    category: FlowRouteCategory.ThankYou,
    component: ThankYouStep,
  },
];

export const actions: FlowActions<B2BLeadFlowContext> = {
  resetProduct,
};
